const styles = (theme) => ({
  forgotButton: {
    padding: '0px',
    minWidth: '0px',
  },
  footerText: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  socialsText: {
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
    fontSize: '14px',
    fontWeight: 500,
  },
  socialButtonsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  socialButton: {
    margin: theme.spacing(.5),
  },
  facebookIcon: {
    width: '18px',
    height: '18px',
    color: theme.palette.common.white,
  },
});

export default styles;
